import {
  configureStore,
  ThunkDispatch,
  AnyAction,
} from '@reduxjs/toolkit';
import { historyMiddleware } from './Middlewares/History.middleware';
import { gtmMiddleware } from './Middlewares/Gtm.middleware';
import reducers, { RootState } from './reducers';
import { productSelectorListener } from './Middlewares/ProductSelector.middleware';
import { productListingListener } from './Middlewares/ProductListing.middleware';

export const createStore = (preloadState) =>
  configureStore({
    preloadedState: preloadState,
    reducer: reducers,
    middleware: [
      historyMiddleware,
      gtmMiddleware,
      productSelectorListener.middleware,
      productListingListener.middleware,
    ],
  });

const store = createStore(global['LitiumPreloadState']);
export type AppDispatch = ThunkDispatch<RootState, any, AnyAction>;
export default store;
